import React, { useState, useEffect, useRef, useMemo } from "react";
import general from "../../options/general.json";
import ReportsExpand from "../common/ReportsExpand";
import Select from "../common/Select";
import { getYearRangeAsArray } from "./../../scripts/helperScripts";

function MonthlyUnits({ divisions, isFavorite, toggleFavorite, ...rest }) {
  const [reportData, setReportData] = useState({
    Company: "",
    Division: "",
    Month: (new Date().getMonth() + 1).toString().replace(/^0+/, ""),
    Year: new Date().getFullYear().toString(),
    Type: "",
  });
  const isMountedRef = useRef(true);

  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  const reportOrg =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "SOARLive"
      : "SOARD365Base";

  const companyOptions = useMemo(() => {
    const groupBy = (xs, key) => {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    };

    const activeDivisions = safyInfo.user.safyInfo.divisions.filter(
      (division) => division.Active === "1"
    );
    const companies = Object.keys(groupBy(activeDivisions, "CompanyName"));
    const options = companies.sort().map((company) => {
      return { _id: company, name: company };
    });
    return options;
  }, [safyInfo.user.safyInfo.divisions]);

  const allDivisionOptions = useMemo(() => {
    const activeDivisions = safyInfo.user.safyInfo.divisions.filter(
      (division) => division.Active === "1"
    );

    const divs = activeDivisions
      .map((division) => {
        return {
          _id: division.DivisionName,
          name: division.DivisionName,
          company: division.CompanyName,
        };
      })
      .sort((a, b) => {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });

    return divs;
  }, [safyInfo.user.safyInfo.divisions]);

  const divisionOptions = useMemo(() => {
    const options = allDivisionOptions.filter(
      (option) => option.company === reportData.Company
    );

    return options;
  }, [allDivisionOptions, reportData.Company]);

  useEffect(() => {
    return () => (isMountedRef.current = false);
  }, []);

  const handleChange = ({ currentTarget: input }) => {
    const data = { ...reportData };
    data[input.name] = input.value;
    setReportData(data);
  };

  const openReport = () => {
    const url = `https://safyreports.azurewebsites.net/Reports/MonthlyUnits/Default?db=${reportOrg}&c=${reportData.Company}&d=${reportData.Division}&m=${reportData.Month}&y=${reportData.Year}&t=${reportData.Type}`;
    window.open(url, "Monthly Units Report");
  };

  const typeOptions = [
    { _id: "Parent", name: "Foster Parents" },
    { _id: "Employee", name: "Staff" },
  ];

  return (
    <ReportsExpand
      title="Monthly Units"
      isFavorite={isFavorite}
      toggleFavorite={toggleFavorite}
      {...rest}
    >
      <div className="row">
        <Select
          className="col col-2"
          name="Company"
          label="Company"
          options={companyOptions}
          onChange={handleChange}
        />
        <Select
          className="col col-2"
          name="Division"
          label="Division"
          options={divisionOptions}
          onChange={handleChange}
        />
        <Select
          className="col col-2"
          name="Month"
          label="Month"
          options={general.month}
          onChange={handleChange}
          value={reportData.Month}
        />
        <Select
          className="col col-2"
          name="Year"
          label="Year"
          options={getYearRangeAsArray().map((year) => {
            const yearStr = `${year}`;
            return { _id: yearStr, name: yearStr };
          })}
          onChange={handleChange}
          value={reportData.Year}
        />
        <Select
          className="col col-2"
          name="Type"
          label="Type"
          options={typeOptions}
          onChange={handleChange}
        />
        {reportData.Company !== "" &&
          reportData.Division !== "" &&
          reportData.Month !== "" &&
          reportData.Year !== "" &&
          reportData.Type !== "" && (
            <i
              className="fas fa-arrow-circle-right fa-3x col col-2 float-end"
              onClick={openReport}
            ></i>
          )}
      </div>
    </ReportsExpand>
  );
}

export default MonthlyUnits;
